import { render, staticRenderFns } from "./dxassetsTradeDetail.vue?vue&type=template&id=502a9b91&scoped=true"
import script from "./dxassetsTradeDetail.vue?vue&type=script&lang=js"
export * from "./dxassetsTradeDetail.vue?vue&type=script&lang=js"
import style0 from "./dxassetsTradeDetail.vue?vue&type=style&index=0&id=502a9b91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502a9b91",
  null
  
)

export default component.exports